/*
 * @Author: zwcong
 * @Description:
 * @Date: 2022-02-23 10:37:30
 * @LastEditTime: 2022-02-24 16:36:38
 * @FilePath: /teacher-h5/src/store/modules/topic.js
 */

import S from 'service'

const state = {
  topicAnswer: null // 历史答题记录
}

// 自定义改变state初始值的方法
const mutations = {
  setInfo(state, data) {
    state.topicAnswer = data
  }
}

// 自定义触发mutations里函数的方法
const actions = {
  async getTopicAnswer({ commit }, data) {
    const { lessonId, studentUserId, index, topicId, topicType } = data
    const result = await S.topic.historyTopicAnswer({
      lessonId,
      studentUserId,
      index,
      topicId,
      topicType
    })
    commit('setInfo', result)
  }
}

const getters = {
  topicAnswer: state => state.topicAnswer
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
